import { Component, Input } from '@angular/core';

@Component({
  selector: 'py-none-accounting-codes-notification',
  templateUrl: './none-accounting-codes-notification.component.html',
  standalone: false,
})
export class NoneAccountingCodesNotificationComponent {
  @Input() tiny: boolean = false;
  @Input() showBorder: boolean = true;

  constructor() {}
}
